import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class InvoiceChargesModalService {

  private selectedInvoiceChargeSubject = new BehaviorSubject<any>(null);
  public selectedInvoiceCharge$ = this.selectedInvoiceChargeSubject.asObservable();

  constructor() { }

  setSelectedInvoiceCharge(invoiceCharge: any): void {
    this.selectedInvoiceChargeSubject.next(invoiceCharge);
  }

  getSelectedInvoiceCharge(): any | null {
    return this.selectedInvoiceChargeSubject.value;
  }

  clearSelectedInvoiceCharge(): void {
    this.selectedInvoiceChargeSubject.next(null);
  }
}

